import { render } from "./EntitySelectorModeloVeiculoTrator.vue?vue&type=template&id=3cdb81f0"
import script from "./EntitySelectorModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script